<template>
  <div class="tb-list-item">
    <div class="tb-list-item-meta">
      <div class="tb-list-item-meta-icon">
        <sl-img type="background" background-size="cover" :previewable="false" class="avatar" v-if="data.imgPath" :src="data.imgPath" :public="true" />
        <Avatar v-else style="background-color: #87d068" :icon="genderIcon" />
      </div>
      <div class="tb-list-item-meta-content">
        <h4 class="tb-list-item-meta-title">
          <!-- <Icon :type="genderIcon" /> -->
          {{data.name}} <span style="font-size:11px;color:rgba(0,0,0,.45);">{{data.genderText}}  {{data.politicText}}</span>
        </h4>
        <div class="tb-list-item-meta-description">
          <span>{{data['company.companyName']}}</span>
          <span style="margin-left:6px;">{{data.groupName}}</span>
        </div>
      </div>
    </div>
    <div class="tb-list-item-content">
      <div class="tb-list-item-content-item">
        <div class="focus">
          <span><!-- <i class="ivu-icon ivu-icon-md-call"></i> -->{{data.phone}}</span>
        </div>
        <p>{{data.examStateText}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    statusIcon() {
      return this.data.status == 0 ? 'success' : 'error'
    },
    genderIcon() {
      return this.data.gender == 0 ? 'ios-man' : 'ios-woman-outline'
    }
  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}

</script>
<style lang='less' scoped>
.tb-list-item {
  display: flex;
  align-items: center;
  // padding: 12px 0;

  .focus {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    overflow: hidden;
  }

  .ivu-icon-logo-android {
    color: rgb(171, 193, 72);
  }

  .ivu-icon-logo-apple {
    color: rgb(11, 11, 10);
  }

  .ivu-icon-logo-html5 {
    color: rgb(228, 77, 38);
  }

  .tb-list-item-meta {
    display: flex;
    flex: 1 1 50%;
    align-items: flex-start;
    font-size: 0;
    align-items: center;
  }

  .tb-list-item-meta-icon {
    font-size: 54px;
    line-height: 0;
    margin-right: 16px;
  }

  .tb-list-item-meta-title {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }

  .tb-list-item-meta-description {
    color: rgba(0, 0, 0, .45);
    font-size: 12px;
    line-height: 22px;
  }

  .tb-list-item-content {
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
    color: rgba(0, 0, 0, .45);
    font-size: 12px;

    .tb-list-item-content-item {
      text-align: right;

      p {
        margin-top: 4px;
        margin-bottom: 0;
        line-height: 22px;
      }
    }

  }
}

</style>
